import type { DoNotMailChoice } from '~/resources/graphql/graphql'

export function doNotMailDefault(
    doNotMailDefaultValue: DoNotMailChoice
): boolean {
    // If the default value is opt in
    if (doNotMailDefaultValue === 'OPT_IN') {
        // Set the value to true
        return false
    } else {
        // Set the value to false
        return true
    }
}

export function doNotMailChecked(
    doNotMailDirection: DoNotMailChoice,
    doNotMail: boolean
): boolean {
    // If checking the checkbox represents opt in
    if (doNotMailDirection === 'OPT_IN') {
        // If the value is do not mail
        if (doNotMail) {
            // Set the checkbox to false
            return false
        } else {
            // Set the checkbox to true
            return true
        }
    }
    // Else checking the checkbox represents opt out
    else {
        // If the value is opt out
        if (doNotMail) {
            // Set the checkbox to true
            return true
        } else {
            // Set the checkbox to false
            return false
        }
    }
}

export function doNotMailValue(
    doNotMailDirection: DoNotMailChoice,
    newValue: boolean
): boolean {
    // If checking the checkbox represents opt in
    if (doNotMailDirection === 'OPT_IN') {
        // If the value is checked
        if (newValue) {
            // Set the doNotMail to false
            return false
        } else {
            // Set the doNotMail to true
            return true
        }
    }
    // Else checking the checkbox represents opt out
    else {
        // If the value is checked
        if (newValue) {
            // Set the doNotMail to true
            return true
        } else {
            // Set the doNotMail to false
            return false
        }
    }
}
